export enum TemplateType {
    SimpleSelector = 1,
    FullSelector = 2,
    ListSelector = 3,
    Form = 4,
}